import { render, staticRenderFns } from "./TransferTotal.vue?vue&type=template&id=410782a2&scoped=true"
import script from "./TransferTotal.vue?vue&type=script&lang=js"
export * from "./TransferTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410782a2",
  null
  
)

export default component.exports